

import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

class MISTab extends React.Component {
  getMainClassName(activity) {
    return activity.type === 'RRHH_MESSAGE' ? 'mars--feed__item important' : 'mars--feed__item'
  }

  getClassName(activity) {
    let ret = ''
    switch (activity.type) {
      case 'BATTLE_WON':
      case 'BATTLE_LOST':
      case 'BUILDING_STARTED':
      case 'BUILDING_COMPLETED':
        ret = 'icon-shield'
        break
      case 'FEDERATION_REWARD':
        ret = 'icon-shield'
        break
      case 'FEDERATION_PUNISHMENT':
        ret = 'icon-shield'
        break
      case 'RRHH_MESSAGE':
        ret = 'icon-rrhh'
        break
      case 'FIRST_POSITION':
        ret = 'icon-ranking1'
        break
      case 'LEADER':
        ret = 'icon-ranking1'
        break
    }
    return ret
  }

  renderRow(activity) {
    const { intl, playersList } = this.props

    const winnerName = playersList[activity.winnerId] && playersList[activity.winnerId].colonyName
    const loserName = playersList[activity.loserId] && playersList[activity.loserId].colonyName

    const buildingName = activity.buildingName
      ? intl.formatMessage({ id: 'buildings.' + activity.buildingName })
      : null
    const buildingLevel = activity.buildingLevel

    let msg
    if (activity.type === 'BATTLE_WON') {
      if (activity.winnerId === activity.attacker) {
        // The effects of the battle is earning/losing a building
        msg = (
          <FormattedMessage
            id="phase.misTab.battleWonBuilding"
            values={{ winner: winnerName, loser: loserName, buildingName, buildingLevel }}
          />
        )
      } else {
        // The effects of the battle is earning/losing money
        msg = (
          <React.Fragment>
            <FormattedMessage
              id="phase.misTab.battleWonCoins"
              values={{ winner: winnerName, loser: loserName, coins: activity.coins }}
            />
            <i className="icon-coin"> </i>
          </React.Fragment>
        )
      }
    } else if (activity.type === 'BATTLE_LOST') {
      if (activity.winnerId === activity.attacker) {
        // The effects of the battle is earning/losing a building
        msg = (
          <FormattedMessage
            id="phase.misTab.battleLostBuilding"
            values={{ winner: winnerName, loser: loserName, buildingName, buildingLevel }}
          />
        )
      } else {
        // The effects of the battle is earning/losing money
        msg = (
          <React.Fragment>
            <FormattedMessage
              id="phase.misTab.battleLostCoins"
              values={{ winner: winnerName, loser: loserName, coins: activity.coins }}
            />
            <i className="icon-coin"> </i>
          </React.Fragment>
        )
      }
    } else if (activity.type === 'FEDERATION_PUNISHMENT') {
      msg = (
        <React.Fragment>
          <FormattedMessage id="phase.misTab.federationPunishment" />
          {activity.players.map((playerId) => (
            <span key={playerId}>{playersList[playerId].colonyName}, </span>
          ))}
        </React.Fragment>
      )
    }

    switch (activity.type) {
      case 'LEADER':
        return (
          <FormattedMessage
            id="phase.misTab.currentLeaderMessage"
            values={{ name: activity.name }}
          />
        )
      case 'RRHH_MESSAGE':
        return (
          <FormattedMessage id="phase.misTab.rrhhMessage" values={{ message: activity.message }} />
        )
      case 'FEDERATION_REWARD':
        return <FormattedMessage id="phase.misTab.federationReward" />
      case 'FEDERATION_PUNISHMENT':
      case 'BATTLE_WON':
      case 'BATTLE_LOST':
        return msg

      default:
        return activity.type + ' ' + activity.data
    }
  }

  render() {
    const { MISInfo } = this.props
    return (
      <div className="mars--content feed">
        <div className="mars--feed">
          {MISInfo.length > 0 ? (
            MISInfo.map((activity, index) => (
              <div key={index} className={this.getMainClassName(activity)}>
                <span className={this.getClassName(activity)}></span>
                <span className="text">{this.renderRow(activity)}</span>
              </div>
            ))
          ) : (
            <div>
              <span className="text">
                <FormattedMessage id="phase.informationPhase_No_Feeds" />
              </span>
            </div>
          )}
        </div>
      </div>
    )
  }
}

MISTab.propTypes = {
  MISInfo: PropTypes.array,
  playersList: PropTypes.object,
}

export default injectIntl(MISTab)
